import callApi from './eventActivtiyService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/activity-reserve`;

export const getEventActivityMemberList = (query) => callApi({
    method: 'GET',
    endpoint: `${basePath}/sic?${query}`
  });
export const getActivityDropdown = (id) => callApi({
    method: 'GET',
    endpoint: `${basePath}/activity/dropdown/${id}`
  });
